import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { SnackBarComponent } from '../components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));
  constructor(private snackBar: MatSnackBar, private breakpointObserver: BreakpointObserver) {}

  showAlert(message: string, type: 'success' | 'warning' | 'error', duration = 3000): void {
    this.isMobile$.subscribe((isMobile) => {
      const panelClass = isMobile ? ['wm-alert-panelClass', 'wm-alert-panelClass--mobile'] : ['wm-alert-panelClass'];

      this.snackBar.openFromComponent(SnackBarComponent, {
        data: { message, type },
        duration: duration,
        verticalPosition: 'top',
        horizontalPosition: 'end',
        panelClass: panelClass,
      });
    });
  }
}
